export default {
  overview: {
    name: "merchant statistics overview",
    version: 6,
    url: "statistics/overview",
    method: "GET",
  },
  orders: {
    name: "merchant statistics orders",
    version: 6,
    url: "statistics/orders",
    method: "GET",
  },
  products: {
    name: "merchant statistics products",
    version: 6,
    url: "statistics/products",
    method: "GET",
  },
  commissions: {
    name: "merchant statistics commissions",
    version: 6,
    url: "statistics/commissions",
    method: "GET",
  },
  transfers: {
    name: "merchant statistics transfers",
    version: 6,
    url: "statistics/transfers",
    method: "GET",
  },
  retryTransfers: {
    name: "merchant statistics transfers retry",
    version: 6,
    url: "statistics/transfers/retry",
    method: "POST",
  },
};
